/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component } from 'vue-property-decorator';
import { ZenObservable } from 'zen-observable-ts';
import { Logger } from '@aws-amplify/core';
import { PubSub } from '../services/PubSubClass';

const logger = new Logger('Mqtt');
@Component
export default class MqttMixIn extends Vue {
  displayState = this.getState();

  //todo: add reconnect support for multiple connections
  actions: Map<string, () => ZenObservable.Subscription> = new Map();
  subscriptions: Map<string, ZenObservable.Subscription> = new Map();

  isWarmingLambdas = false;

  addMqttVisibility(topic: string, action: () => ZenObservable.Subscription) {
    this.actions.set(topic, action);
    this.addMqttVisibilityHandler();
  }

  private addMqttVisibilityHandler() {
    this.clearMqttVisibilityHandler();
    ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume'].forEach((type) => {
      window.addEventListener(type, this.onDisplayStateChange, { capture: true });
    });
  }

  removeMqttVisibility() {
    this.subscriptions.forEach((type) => {
      type.unsubscribe();
    });
    this.actions.clear();
    this.subscriptions.clear();
    this.clearMqttVisibilityHandler();
  }

  private clearMqttVisibilityHandler() {
    ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume'].forEach((type) => {
      window.removeEventListener(type, this.onDisplayStateChange, { capture: true });
    });
  }

  getState() {
    if (document.visibilityState === 'hidden') {
      return 'hidden';
    }
    if (document.hasFocus()) {
      return 'active';
    }
    return 'passive';
  }

  onDisplayStateChange() {
    const prevState = this.displayState;
    const nextState = this.getState();
    if (nextState !== prevState) {
      logger.debug(`${this.$options.name} : State changed: ${prevState} >>> ${nextState}`);
      this.displayState = nextState;

      if (nextState === 'active') {
        this.subscriptions.forEach((sub, key) => {
          if (sub.closed) {
            const action = this.actions.get(key);
            if (action != undefined) {
              this.subscriptions.set(key, action());
            }
          }
        });
      }
    }
  }

  resetConnection() {
    this.subscriptions.forEach((type) => {
      type.unsubscribe();
    });
    this.subscriptions.clear();
    PubSub.restartAWSIoTProvider(`ws://${localStorage.machineIp}:${localStorage.mqttWebSocketPort}/mqtt`);
    this.actions.forEach((act, key) => {
      this.subscriptions.set(key, act());
    });
  }

  mqttError(error: unknown) {
    logger.error(error);
  }
}
